// extracted by mini-css-extract-plugin
export default {"ldsDualRing":"loading_ldsDualRing__zQa4M","light":"loading_light__m-g-k","lds-dual-ring":"loading_lds-dual-ring__FyvOa"};